import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  sections: {},
  defaultRoutes: {},
  depotStats: {},
  loading: false,
  error: null,
};

export const successSectionsFetch = createAsyncThunk(
  'sections/fetchSections',
  async (data, { rejectWithValue }) => {
    try {
      const sections = data.section.reduce((acc, item) => {
        acc[item.sectionCode] = item;
        return acc;
      }, {});

      const defaultRoutes = data.defaultRoutes.reduce((acc, route) => {
        acc[route.routeId] = route;
        return acc;
      }, {});

      return {
        sections,
        defaultRoutes,
        depotStats: data.depotStats,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {
    sectionsLoaded(state, action) {
      state.sections = action.payload;
    },
    defaultRoutesLoaded(state, action) {
      state.defaultRoutes = action.payload;
    },
    depotStatsLoaded(state, action) {
      state.depotStats = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(successSectionsFetch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(successSectionsFetch.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload.sections;
        state.defaultRoutes = action.payload.defaultRoutes;
        state.depotStats = action.payload.depotStats;
      })
      .addCase(successSectionsFetch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { sectionsLoaded, defaultRoutesLoaded, depotStatsLoaded } =
  sectionsSlice.actions;

export default sectionsSlice.reducer;
